import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import EmailToTarget from './ActionStats/EmailToTarget'
import './PageContainer.scoped.scss'

function StepLabel({ step, index }) {
    const formattedName = step.name.charAt(0).toUpperCase() + step.name.slice(1).replace(/_/g, ' ')
    return <p key={index}>{formattedName}</p>
}

function FlowSteps({ }) {
    const { id, name, stats, actions } = useSel((s) => s.flow)

    const stepsData = (stats?.steps || []).map((step) => {
        return {
            name: step.kind,
            amountLeft: step.total - step.completed,
            completed: step.completed,
            total: step.total
        }
    })

    const emailToTargetAction = useMemo(() => actions?.find((action) => action.kind === 'email_to_target'), [actions])

    return <>
        <div className='box flex column margin-top double' id='page'>
            <h1 className='no-margin-top'>Page Steps</h1>
            <div className="step-container">
                <div className="info">
                    <div className="example-box">
                        <span className="color-swatch" style={{ background: '#00F399' }}></span>
                        <p>Completed</p>
                    </div>
                    <div className="example-box">
                        <span className="color-swatch" style={{ background: 'rgba(24, 24, 91, 0.2)' }}></span>
                        <p>Started</p>
                    </div>
                </div>
                <div className="data">
                    <div className="chart-keys">
                        {stepsData.map((step, index) => (
                            <StepLabel step={step} index={index} />
                        ))}
                    </div>
                    <ResponsiveContainer width="100%" height={stepsData.length * 42}>
                        <BarChart
                            layout="vertical"
                            data={stepsData}
                            barSize={20}
                        >
                            <YAxis dataKey="name" type="category" width={100} hide={true} />
                            <XAxis type="number" hide={true} />
                            <Bar dataKey="completed" stackId="a" fill="#00F399" />
                            <Bar dataKey="amountLeft" stackId="a" fill="rgba(24, 24, 91, 0.1)" />
                        </BarChart>
                    </ResponsiveContainer>
                    <div className="text-data">
                        {stepsData.map((step, index) => (
                            <p key={index}>{step.completed}/{step.total}</p>
                        ))}
                    </div>
                </div>
            </div>
        </div>
        {emailToTargetAction &&
            <EmailToTarget flowId={id} flowName={name} actionId={emailToTargetAction.id} />
        }
    </>
}

export default FlowSteps